module.exports = {
  skills: [
    {
      title: ["Web", "Languages"],
      data: [
        { title: "JavaScript", value: 40, color: "#f1e05a" },
        { title: "TypeScript", value: 25, color: "#2b7489" },
        { title: "Kotlin", value: 10, color: "#f18e33" },
        { title: "Java", value: 10, color: "#b07219" },
        { title: "Php", value: 20, color: "#4f5d95" },
        { title: "python", value: 10, color: "#3572a5" },
        { title: "Dart", value: 2, color: "#00b4ab" },
      ],
    },
    {
      title: ["Web", "FrontEnd"],
      data: [
        { title: "React", value: 40, color: "#01D6F4" },
        { title: "Css", value: 30, color: "#563d7c" },
        { title: "html", value: 30, color: "#e34c26" },
        { title: "sass", value: 10, color: "#B6519E" },

        { title: "Bootstrap, bulma ,tailwind", value: 10, color: "#7FB17D" },
        { title: "Other", value: 5, color: "#ECD078" },
      ],
    },
    {
      title: ["Web", "BackEnd"],
      data: [
        { title: "Express", value: 40, color: "#556270" },
        { title: "Koa", value: 20, color: "#4ECDC4" },
        { title: "Nestjs", value: 15, color: "#C7F464" },
        { title: "Flask", value: 10, color: "#FF6B6B" },
        { title: "Django", value: 10, color: "#C44D58" },
        { title: "Other", value: 5, color: "#ECD078" },
      ],
    },
    {
      title: ["Web", "DataBase"],
      data: [
        { title: "MySql", value: 40, color: "#00758f" },
        { title: "MongoDb", value: 20, color: "#589636" },
        { title: "SqlServer", value: 15, color: "#f29111" },
      ],
    },
    {
      title: ["Web", "devObs"],
      data: [
        
        { title: "Azure", value: 20, color: "#6762a6" },
        { title: "Cpanel", value: 15, color: "#ff9900" },{ title: "Heroku", value: 50, color: "#146eb4" }
      ],
    },
    {
      title: ["Aplications", "Desktop and Movil"],
      data: [
        { title: "React Native", value: 50, color: "#B63C49" },
        { title: "Electron", value: 30, color: "#C8A87F" },
        { title: "Ionic", value: 10, color: "#f29111" },
        { title: "Androi Kotlin", value: 20, color: "#E6C1B1" },
      ],
    },
  ],
  ruta:"https://pamsho-web.herokuapp.com"
};
/*colors
#D1CAB2
#E68627
#8CBBBD
#005661
#033D4F


*/
